import {
  clearSignedInHint,
  readSignedInHint,
  SignedInHintStorage,
  writeSignedInHint,
} from 'fym-shared/src/music24/signedInHint';

/**
 * The web app side of the signed-in hint (fym-shared `music24/signedInHint.ts`): a note in
 * `localStorage` that music24.com reads to greet a signed-in person. It holds the first name only,
 * never the token.
 */
const browserStorage = (): SignedInHintStorage | null => {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null;
  }
};

/** Writes the note now. Never throws. */
export function storeSignedInHint(firstName: string | null | undefined): void {
  writeSignedInHint(browserStorage(), firstName, Date.now());
}

/** Writes a note with no name when no valid note exists (a new session). Never throws. */
export function storeSignedInHintIfMissing(): void {
  const storage = browserStorage();
  if (readSignedInHint(storage, Date.now()) === null) {
    writeSignedInHint(storage, null, Date.now());
  }
}

/** Removes the note (sign-out, a session that ended). Never throws. */
export function removeSignedInHint(): void {
  clearSignedInHint(browserStorage());
}
